import type { AgentMessage } from "@/hooks/use-stream-conversation";
import { type PlainAgentExecution } from "@/queries/agent-queries";

export const agentExecutionName = (agentExecution: PlainAgentExecution) =>
    agentExecution.metadata?.name || "New conversation";

export const messageToText = (message: AgentMessage) => {
    return message.fragments
        .map((fragment) => {
            switch (fragment.type) {
                case "text":
                    return fragment.content;
                case "action":
                    return `Action: ${fragment.intentDescription}`;
                case "fileModification":
                    return `File modification: ${fragment.filePath}`;
                case "environmentCreation":
                    return `Environment created: ${fragment.environmentId}`;
                case "thinking":
                    return `Thinking: ${fragment.content}`;
            }
        })
        .join("\n\n");
};
